import {lazy} from 'react';

export const LazyAlertMessage = lazy(() => import(/* webpackChunkName: "alertMessage" */ 'app/core/alerts/alertMessage'));
